import { useEffect, useRef } from 'react'

import { SCROLL_KEYS } from '../../constants/common'
import {
  EVENT_NAME_KEY_DOWN,
  EVENT_NAME_SCROLL,
  EVENT_NAME_TOUCH_MOVE,
  EVENT_NAME_WHEEL,
} from '../../constants/event'
import { isKeyDownEvent } from '../../utils/events'

export function useUserAncestorScroll({
  closeOnUserAncestorScroll = false,
  context,
  onOpenChange,
}) {
  const userScrollIntentRef = useRef(false)

  useEffect(() => {
    const floatingEl = context.refs?.floating?.current
    const referenceEl = context.refs?.reference?.current

    function isInside(e) {
      return floatingEl?.contains(e.target) || referenceEl?.contains(e.target)
    }

    if (closeOnUserAncestorScroll) {
      function markUserIntent(e) {
        if (isKeyDownEvent(e)) {
          if (!SCROLL_KEYS.has(e.key)) {
            return
          }
        }

        if (isInside(e)) {
          return
        }

        userScrollIntentRef.current = true
      }

      function handleScroll(e) {
        if (!context.open) {
          return
        }

        if (!userScrollIntentRef.current) {
          return
        }

        if (isInside(e)) {
          return
        }

        userScrollIntentRef.current = false
        onOpenChange?.(false)
      }

      if (context.open) {
        window.addEventListener(EVENT_NAME_WHEEL, markUserIntent, true)
        window.addEventListener(EVENT_NAME_TOUCH_MOVE, markUserIntent, true)
        window.addEventListener(EVENT_NAME_KEY_DOWN, markUserIntent, true)
        window.addEventListener(EVENT_NAME_SCROLL, handleScroll, true)
      }

      return () => {
        window.removeEventListener(EVENT_NAME_WHEEL, markUserIntent, true)
        window.removeEventListener(EVENT_NAME_TOUCH_MOVE, markUserIntent, true)
        window.removeEventListener(EVENT_NAME_KEY_DOWN, markUserIntent, true)
        window.removeEventListener(EVENT_NAME_SCROLL, handleScroll, true)
      }
    }
  }, [closeOnUserAncestorScroll, context, onOpenChange])
}
